<template>
  <div>
    <div class="title-item">
      <div class="left-label">
        <div class="title-line"></div>
        <div class="title-text">业务流程</div>
      </div>
      <div class="right-value" v-if="info.basicInfo.signOrder">
        <img
          src="../../../../assets/images/business/bj.png"
          class="bj-image"
          alt=""
        />
        <div>
          <!-- signOrder：0：无序，1： 债权人先签署， 2： 债务人先签署 -->
          <span v-if="info.basicInfo.signOrder === '1'">债权人先签署</span>
          <span v-if="info.basicInfo.signOrder === '2'">债务人先签署</span>
        </div>
      </div>
    </div>

    <div class="flow-box">
      <div class="flow-item" v-for="(item, index) in info.processList" :key="index">
        <div class="flow-title">
          <div>{{ item[0].notaryEventType }}</div>
        </div>
        <div class="flow-content" v-for="(item2, index2) in item" :key="index2">
          <div class="line"></div>
          <div class="item-body">
            <div class="item-title">
              <div class="label">{{ item2.operator }}</div>
              <div class="value">{{ item2.actionName }}</div>
            </div>
            <div class="item-time">{{ item2.time }}</div>
            <div class="item-intro-box" v-for="(value, key) in item2.params" :key="key">
              <div class="intro-title">{{ key }}</div>
              <div class="intro-content">
                <div class="intro-value">
                  {{ value }}
                </div>
                <div class="image-box" v-if="key === '区块链记录'" @click="copyToClipboard(value)">
                  <img class="fz-image" src="../../../../assets/images/business/fz.png" alt="" />
                  <span class="copy">复制</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
      
<script>
import Util from "@lib/util.js";

export default {
  name: "",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  components: {},

  data() {
    return {};
  },

  created() {},
  mounted() {},

  methods: {
    copyToClipboard: Util.copyToClipboard,
  },
};
</script>
      
<style scoped lang='scss'>
.title-item {
  padding: 0 15px;
  display: flex;
  align-items: center;
  .left-label {
    display: flex;
    align-items: center;

    .title-line {
      width: 4px;
      height: 19px;
      background: #d81212;
      border-radius: 4px;
    }
    .title-text {
      margin-left: 9px;
      color: #787878;
      font-size: 15px;
      font-weight: bold;
    }
  }
  .right-value {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    color: #787878;
    line-height: 15px;
    font-size: 13px;
    .bj-image {
      width: 15px;
      height: 15px;
      margin-right: 8px;
    }
  }
}

.flow-box {
  margin-top: 23px;
  padding: 0 15px 0 30px;
  .flow-item {
    margin-bottom: 23px;
    .flow-title {
      font-size: 13px;
      color: #505050;
      line-height: 15px;
      margin-bottom: 11px;
    }

    .flow-content {
      display: flex;
      justify-content: flex-end;
      &:last-child {
        .item-body {
          margin-bottom: 0;
        }
      }
      .line {
        width: 1px;
        background: #db1c1b;
      }
      .item-body {
        width: 293px;
        background: #ffffff;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.2);
        border-radius: 2px;
        margin-left: 19px;
        padding: 11px;
        box-sizing: border-box;
        margin-bottom: 12px;
        .item-title {
          display: flex;
          align-items: center;
          font-size: 13px;
          font-weight: 400;
          color: #505050;
          line-height: 15px;
          .label {
            max-width: 170px;
          }
          .value {
            flex: 1;
            text-align: right;
          }
        }
        .item-time {
          color: #7b7b7b;
          line-height: 15px;
          height: 15px;
          font-size: 11px;
          margin-top: 4px;
        }

        .item-intro-box {
          background: #f8f8f8;
          border-radius: 2px;
          padding: 4px 11px;
          font-weight: 400;
          color: #7b7b7b;
          line-height: 15px;
          font-size: 11px;
          margin-top: 8px;
          .intro-title {
            margin-bottom: 4px;
          }
          .intro-content {
            display: flex;
            align-items: flex-start;
            .intro-value {
              word-break: break-all;
              flex: 1;
            }
            .image-box {
                flex-shrink: 0;
                display: flex;
                align-items: center;
                margin-left: 10px;
                line-height: 16px;
                cursor: pointer;
                .copy {
                    color: #DB1C1B;
                    margin-left: 4px;
                }
            }
          }
        }
      }
    }
  }
}
</style>
      